import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";
// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { changePassword } from "../../actions/auth";
import {
  TextField,
  FormControl,
  OutlinedInput,
  Input,
  InputLabel,
  InputAdornment,
} from "@material-ui/core";

// import Alert from "../../components/alert/alert.component";

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: "",
      oldPassword: "",
      oldPasswordError: "",
      newPassword: "",
      newPasswordError: "",
      success: null,
      showInputs: true,
    };
  }
  handlePasswordChange = (e) => {
    const target = e.target;
    if (target.value.length < 1) {
      console.log("handleUsernameChange()");
      this.setState({
        oldPassword: target.value,
        oldPasswordError: (
          <h4 className="mb-0 password-error">Enter Your Old Password</h4>
        ),
      });
      console.log(this.state.passwordError);
    } else {
      this.setState({
        oldPassword: target.value,
        oldPasswordError: "",
      });
    }
  };
  handleNewPasswordChange = (e) => {
    const target = e.target;
    if (target.value.length < 6) {
      console.log("handleUsernameChange()");
      this.setState({
        newPassword: target.value,
        newPasswordError: (
          <h4 className="mb-0 password-error">
            {" "}
            New Password must be at least 6 charactor long
          </h4>
        ),
      });
      /*   console.log(this.state.passwordError) */
    } else {
      this.setState({
        newPassword: target.value,
        newPasswordError: "",
      });
    }
  };

  onSubmit = async () => {
    const { oldPassword, newPassword } = this.state;

    const formData = {
      email: this.props._auth.user.email,
      oldPassword,
      newPassword,
    };

    const res = await this.props.changePassword(formData);
    if (oldPassword.length < 1) {
      this.setState({
        oldPasswordError: (
          <h4 className="mb-0 password-error">Enter Your Old Password</h4>
        ),
      });
      return;
    }
    if (newPassword.length < 6) {
      this.setState({
        newPasswordError: (
          <h4 className="mb-0  password-error">
            New Password must be at least 6 charactor long
          </h4>
        ),
      });
      return;
    }

    if (res && res.status === 200) {
      this.setState({
        showInputs: !this.state.showInputs,
        success: (
          <h4 className="mb-0 password-success-msg">
            {" "}
            Password changed successfully
          </h4>
        ),
      });
      setTimeout(() => {
        this.setState({ success: null });
      }, 4000);
    } else {
      this.setState({
        success: <h4 className="mb-0  password-error">Password Not match</h4>,
      });
      setTimeout(() => {
        this.setState({ success: null });
      }, 4000);
    }
  };

  render() {
    return (
      <Fragment>
        <div className="personal-info-wrapper wrapper-90 max-1600">
          <ul className="breadcrumb">
            <li>
              <a href="index.html">
                <i className="fa fa-home" />
              </a>
            </li>
            <li>
              <Link to="/dashboard"> / Account</Link>
            </li>
            <li>
              <a href=""> / Change Password</a>
            </li>
          </ul>
          <div className="container-fluid">
            <div className="row">
              {/* <AccountLeftSidebar /> */}
              <div className="col-md-12">
                <div className="bg-cream p-3">
                  {this.state.showInputs ? (
                    <div className="personal-info-heading">
                      <h3 className="p-info-heading-title">Personal Info</h3>
                      <span className="p-info-heading-hints">
                        To make updates, type your new info in the form field
                        you want to change and click the SAVE button.
                      </span>
                    </div>
                  ) : null}
                  <div className="pi-saved">
                    {this.state.success && (
                      <p
                        key={alert.id}
                        variant={alert.alertType}
                        className={`alert alert-success info-updated`}
                        role="alert"
                      >
                        {this.state.success}
                      </p>
                    )}
                  </div>
                  <section className="personal-i-section">
                    <div className="pi-section-content">
                      {this.state.showInputs ? (
                        <>
                          <div className="pi-section-header">
                            <h2 className="pi-section-title">
                              Change Password
                            </h2>
                          </div>
                          <div className="pi-section-inputs">
                            <div className="pi-currentPsw-inp">
                              <label
                                htmlFor="currentPsw"
                                className="pi-text-field"
                              >
                                <FormControl
                                  variant="outlined"
                                  className="my-2"
                                >
                                  <TextField
                                    variant="outlined"
                                    id="component-outlined"
                                    name="phone"
                                    type={
                                      this.state.showPassword
                                        ? "text"
                                        : "password"
                                    }
                                    maxLength={32}
                                    value={
                                      this.state.oldPassword &&
                                      this.state.oldPassword
                                    }
                                    onChange={(e) => {
                                      this.handlePasswordChange(e);
                                    }}
                                    error={
                                      this.state.oldPasswordError &&
                                      this.state.oldPasswordError !== ""
                                        ? true
                                        : false
                                    }
                                    label="Old Password"
                                    helperText={
                                      this.state.oldPasswordError &&
                                      this.state.oldPasswordError
                                    }
                                  />
                                </FormControl>
                                {/* <input
                            id="pi-currentPsw"
                            className="pi-input pi-currentPsw"
                            type="password"
                            name="password"
                            value={this.state.oldPassword}
                            onChange={(e) => {
                              this.setState({ oldPassword: e.target.value });
                            }}
                          />
                          <span className="pi-placeholder">Old Password</span> */}
                              </label>
                            </div>
                            <div className="pi-newPsw-inp">
                              <FormControl variant="outlined" className="my-2">
                                <TextField
                                  variant="outlined"
                                  id="component-outlined"
                                  name="phone"
                                  type={
                                    this.state.showPassword
                                      ? "text"
                                      : "password"
                                  }
                                  maxLength={32}
                                  value={
                                    this.state.newPassword &&
                                    this.state.newPassword
                                  }
                                  onChange={(e) => {
                                    this.handleNewPasswordChange(e);
                                  }}
                                  error={
                                    this.state.newPasswordError &&
                                    this.state.newPasswordError !== ""
                                      ? true
                                      : false
                                  }
                                  label="New Password"
                                  helperText={
                                    this.state.newPasswordError &&
                                    this.state.newPasswordError
                                  }
                                />
                              </FormControl>
                              {/* <label htmlFor="newPsw" className="pi-text-field">
                          <input
                            type="password"
                            id="pi-newPsw"
                            className="pi-input pi-newPsw"
                            name="confirm"
                            onChange={(e) => {
                              this.setState({ newPassword: e.target.value });
                            }}
                          />
                          <span className="pi-placeholder">New Password</span>
                        </label> */}
                            </div>
                          </div>
                        </>
                      ) : null}
                    </div>
                  </section>

                  <div className="pi-bottom">
                    <div className="piBack-save-btns">
                      <Link to={"/dashboard"} className="back-from-pi">
                        <button>
                          <span>Back to My Account</span>
                        </button>
                      </Link>
                      {this.state.showInputs ? (
                        <div className="save-pi">
                          <button
                            className="savePersona-info"
                            onClick={() => {
                              this.onSubmit();
                            }}
                          >
                            <span>Save</span>
                          </button>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

changePassword.propTypes = {
  changePassword: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  _auth: state.auth,
});

export default withRouter(
  connect(mapStateToProps, { changePassword })(ChangePassword)
);
